import { combineReducers } from 'redux';
import getApiReducer from '../common/utils/getApiReducer';
import { fromJS } from 'immutable';

import { GET_ALL_USERS, MAKE_USER_MOVEMENT_SPECIALIST, UNLOCK_COURSE } from './actions';

const usersReducer = getApiReducer(GET_ALL_USERS);
const users = (state, action) => {
  const newState = usersReducer(state, action);

  if (action.type === `${UNLOCK_COURSE}_SUCCESS`) {
    const users = newState.getIn(['data', 'results']);
    const userIndex = users.findIndex(item => item.get('id') === action.userId);
    const unlockedCourses = users.getIn([userIndex, 'unlockedCourses']);

    return newState.setIn(
      ['data', 'results', userIndex, 'unlockedCourses'],
      unlockedCourses.push(fromJS(action.course))
    );
  }

  if (action.type === `${MAKE_USER_MOVEMENT_SPECIALIST}_SUCCESS`) {
    const users = newState.getIn(['data', 'results']);
    const userIndex = users.findIndex(item => item.get('id') === action.json.id);
    const newUser = users.get(userIndex).merge(fromJS(action.json));

    return newState.setIn(['data', 'results', userIndex], newUser);
  }

  return newState;
};

export default combineReducers({
  makeMovementSpecialist: getApiReducer(MAKE_USER_MOVEMENT_SPECIALIST),
  users,
  unlockCourse: getApiReducer(UNLOCK_COURSE),
});



// WEBPACK FOOTER //
// ./src/users/reducers.js